import PlainTextCell from 'components/PlainTextCell';

import { parseDate } from 'utils/dates';

interface CellProps {
  rowData: {
    createdAt?: string | null;
    scheduledForDeletionAt?: string | null;
  };
}

export default function CreatedAtCell({
  rowData: { createdAt, scheduledForDeletionAt },
}: CellProps) {
  if (!createdAt) {
    return <PlainTextCell topLine={undefined} />;
  }

  const [topLine, bottomLine] = parseDate(createdAt);

  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      {...{ topLine, bottomLine }}
    />
  );
}
